import { Stack } from '@mui/system';
import { useState, useMemo } from 'react';
import FilterDialog from './FilterDialog';
import { FilterListRounded } from '@mui/icons-material';
import { IconButton, Typography, Chip } from '@mui/material';
import React from 'react';
import { useLogUserActionMutation } from '../../api/apiSlice';

function FilterManager(props) {
    const [isShowingFiltersDialog, setIsShowingFiltersDialog] = useState(false);
    const [logUserAction] = useLogUserActionMutation();

    function handleApplyFilters(filters) {
        props.setAppliedFilters(filters);
        logUserAction({ action: 'applied_campaign_monitoring_filters', data: { filterSet: filters, } });
        setIsShowingFiltersDialog(false);
    }

    // Because we are now initialising the list of filters in the parent campaign monitoring component, 
    // passing it down to both the filter manager and the filter dialog is causing issues since we pass the same object reference.
    // So we create a deep copy here to ensure that the manager and dialog edit a copy and set the original, as opposed to editing the original.
    const dialogFilters = useMemo(() => {
        return structuredClone(props.appliedFilters);
    }, [props.appliedFilters]);

    return (
        <Stack direction='row' spacing={2}>
            <IconButton onClick={() => setIsShowingFiltersDialog(true)}>
                <FilterListRounded />
            </IconButton>
            { Object.values(props.appliedFilters).some((filter) => filter.selected) &&
                <Stack direction='row' spacing={1} alignItems='center'>
                    <Typography variant='normal' fontSize='14px'>Active Filters:</Typography>
                    { Object.values(props.appliedFilters).filter((filter) => filter.selected).map((filter) => (
                        <Chip key={filter.name} label={`${filter.name}: ${filter.selectedOptions.join(', ')}`} />
                    ))}
                </Stack>
            }
            <FilterDialog 
                key={isShowingFiltersDialog ? 'open' : 'closed'}
                dialogTitle='Campaign Filters'
                open={isShowingFiltersDialog} 
                setOpen={setIsShowingFiltersDialog} 
                filters={dialogFilters}
                handleApplyFilters={handleApplyFilters}
            />
        </Stack>
    );
}

export default FilterManager;

